import { type ContentItem } from './ContentItem.types';

export const getContentItemForLocale = (contentItems: ContentItem[], locale: string = 'en') =>
    contentItems.find(item => item.locale === locale) || contentItems.find(item => item.locale === 'en');
